var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#690DD3;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_9adbe8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_4_\\u043A\\u043E\\u043F\\u0438\\u044F_",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 4 (\\u043A\\u043E\\u043F\\u0438\\u044F)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 42,
    height: 42
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_3",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.5,
    y: 11.5,
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.5,
    y: 15.5,
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.5,
    y: 19.5,
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21,25a2,2,0,0,0-2,1.92V27a2,2,0,0,0,4,0V26.9A2,2,0,0,0,21,25Zm0,0a2,2,0,0,0-2,1.92V27a2,2,0,0,0,4,0V26.9A2,2,0,0,0,21,25ZM21,2.5A18.5,18.5,0,1,0,39.5,21,18.5,18.5,0,0,0,21,2.5Zm-3.48,30H13.31a.8.8,0,0,1-.81-.84V10.44a.89.89,0,0,1,.81-.94H28.69a.89.89,0,0,1,.81.94V31.66a.8.8,0,0,1-.81.84H24.48V29.79a4.48,4.48,0,1,0-7,0Zm6,4.63L21,35.19l-2.52,1.94V30.68a4.51,4.51,0,0,0,5,0ZM24,28.77h0a4.11,4.11,0,0,1-.48.62,3.5,3.5,0,0,1-5,0,4.11,4.11,0,0,1-.48-.62h0l-.08-.13a3.64,3.64,0,0,1-.4-1.31c0-.12,0-.24,0-.36a3.5,3.5,0,0,1,7,0c0,.12,0,.24,0,.36a3.64,3.64,0,0,1-.4,1.31Zm7.5,3.05a2.65,2.65,0,0,1-2.62,2.68h-4.4v-1h4.21a1.81,1.81,0,0,0,1.81-1.84V10.44A1.88,1.88,0,0,0,28.69,8.5H13.31a1.88,1.88,0,0,0-1.81,1.94V31.66a1.81,1.81,0,0,0,1.81,1.84h4.21v1h-4.4a2.65,2.65,0,0,1-2.62-2.68V10.27A2.73,2.73,0,0,1,13.12,7.5H28.88a2.73,2.73,0,0,1,2.62,2.77ZM21,25a2,2,0,0,0-2,1.92V27a2,2,0,0,0,4,0V26.9A2,2,0,0,0,21,25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo_1.d7e63fc44c6e4c64a89a49a2e5e1bb75.svg";
export { ForwardRef as ReactComponent };